import {Column, Entity, JoinTable, ManyToMany, ManyToOne, PrimaryGeneratedColumn} from "typeorm"
import { Product } from "./Products"
import { Order } from "./Order"
import { AssociatedProduct } from "./AssociatedProduct"

@Entity()
export class OrderItem {

	@PrimaryGeneratedColumn()
  id?: number

  @ManyToOne(type => Product)
  product?: Product
	
  @Column()
  quantity?: number
  
  @Column()
  price?: number

  @ManyToOne(() => Order, (order:Order) => order.items)
  order?: Order
}